import {
  NumbersLookRight,
  ChangeTheseValues,
} from '../../../../constants/trackingEvents'
import { IconCheck, IconWrench } from '../../Icon'
import { defineMessages, useIntl } from 'react-intl'
import { Button, Format, List, Text } from '../../..'
import { AdditionalInfo } from '../../AdditionalInfo'
import { Loan } from '@homebot/shared-util-quartermaster/types'
import { ButtonGroup } from '@homebot/shared-ui-swashbuckle'
import styles from './ConfirmLoanDetailsInfo.module.scss'

export const MSG = defineMessages({
  doubleCheckNumbers: {
    id: 'Homeowner.interest.doubleCheckNumbers',
    defaultMessage: 'Quick check, we found these loans from public records:',
  },
  doubleCheckDesc: {
    id: 'Homeowner.interest.doubleCheckLoanDescription',
    defaultMessage: '{termYears} year loan at {rate} for {amount} from {date}',
  },
  looksRight: {
    id: 'General.looksRight',
    defaultMessage: 'That looks right',
  },
  changeNumbers: {
    id: 'General.changeTheseNumbers',
    defaultMessage: 'Change these numbers',
  },
})

interface ConfirmLoanDetailsInfoProps {
  loans: Loan[]
  handleConfirmLoans: () => void
  handleUpdateLoanClick: () => void
  shouldCheckNumbers: boolean
}

export const ConfirmLoanDetailsInfo = ({
  loans,
  handleConfirmLoans,
  handleUpdateLoanClick,
  shouldCheckNumbers,
}: ConfirmLoanDetailsInfoProps) => {
  const intl = useIntl()

  return (
    <AdditionalInfo
      visible={shouldCheckNumbers}
      headingText={intl.formatMessage(MSG.doubleCheckNumbers)}
    >
      <List.Bulleted className={styles.loanList}>
        {loans.map(loan => (
          <Text
            key={loan.id}
            className={styles.loanItem}
            size='s'
            variant='neutralCool'
            variantCount='900'
          >
            {intl.formatMessage(MSG.doubleCheckDesc, {
              termYears: loan.termYears || loan.termYearsEstimated,
              rate: (
                <Text element='span' variant='success'>
                  {loan.rate || loan.rateEstimated}%
                </Text>
              ),
              amount: (
                <Text element='span' variant='success'>
                  <Format.Currency value={loan.amount} />
                </Text>
              ),
              date: <Format.Date value={loan.date} format='MMMM YYYY' />,
            })}
          </Text>
        ))}
      </List.Bulleted>

      <ButtonGroup>
        <Button
          onClick={handleConfirmLoans}
          iconStart={IconCheck}
          track={NumbersLookRight}
          data-qa='confirm'
        >
          {intl.formatMessage(MSG.looksRight)}
        </Button>
        <Button
          onClick={handleUpdateLoanClick}
          iconStart={IconWrench}
          track={ChangeTheseValues}
          data-qa='change'
          className='exp-FromDigestButton_ToEditLoan'
        >
          {intl.formatMessage(MSG.changeNumbers)}
        </Button>
      </ButtonGroup>
    </AdditionalInfo>
  )
}
